export default __webpack_public_path__ + "static/media/truck.1fa7672d.svg";